// extracted by mini-css-extract-plugin
export default {"loginForm":"Login_loginForm__TeyCL"};